export default __webpack_public_path__ + "static/media/10.0606bb1a.jpg";